import { queryOptions, useMutation } from "@tanstack/react-query";

import type { UserCompanyAssignRequest } from "@/generated/api/users";
import {
  assignUserCompany,
  block,
  getUser,
  unblock,
} from "@/generated/api/users";

const userQuery = ({ ssoUserId }: { ssoUserId: string }) =>
  queryOptions({
    queryFn: ({ signal }) => getUser(ssoUserId, { signal }),
    queryKey: ["user", ssoUserId],
  });

const useBlockUserMutation = () =>
  useMutation({
    mutationFn: ({
      ssoUserId,
      blocked,
    }: {
      ssoUserId: string;
      blocked: boolean;
    }) =>
      blocked
        ? block(encodeURIComponent(ssoUserId))
        : unblock(encodeURIComponent(ssoUserId)),
  });

const useAssignUserCompanyMutation = () =>
  useMutation({
    mutationFn: ({
      userId,
      data,
    }: {
      userId: string;
      data: UserCompanyAssignRequest;
    }) => assignUserCompany(encodeURIComponent(userId), data),
  });

export { useAssignUserCompanyMutation, useBlockUserMutation, userQuery };
